import React, { useState } from "react";
import { Column, MasterDetail, GroupItem, Summary, TotalItem } from "devextreme-react/data-grid";
import { LVGridCabecera } from "../../Componentes/Basicos/LVGridCabecera";
import { PaginaListado } from "../../Componentes/Compuestos/Paginas/PaginaListado";
import VEN_Reservas_Detalle from "./VEN_Reservas_Detalle";
import LVButtonNuevo from "../../Componentes/Basicos/LVButtonNuevo";
import LVButtonReporte from "../../Componentes/Basicos/LVButtonReporte";
import { FormateoFechaPara_yyyyMMdd } from "neftis7_apicaller/src/funciones/Varios";
import { function_ABM_EEX_Clientes_Leer } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Clientes";

export const VEN_Reservas_ = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [dataLeible, setDataLeible] = useState("")

  const [FechaDesde, setFechaDesde] = useState(new Date());
  const [FechaHasta, setFechaHasta] = useState(new Date());

  const { VEN_Reservas_Cabecera: { function_VEN_Reservas_Cabecera_ReporteReserva, function_VEN_Reservas_Cabecera_ReporteReserva_EnvioMail, function_VEN_Reservas_Cabecera_Listar, function_VEN_Reservas_Cabecera_ResumenLeible } } = require('neftis7_apicaller');
  const { VariablesGenerales: { DiasParaDesdeListados, DiasParaHastaListados } } = require('neftis7_apicaller');

  const handleDataLoaded = async (data) => {
    setData(data);
    try {
      const resultReservasResumenLeible = await function_VEN_Reservas_Cabecera_ResumenLeible(FormateoFechaPara_yyyyMMdd(FechaDesde), FormateoFechaPara_yyyyMMdd(FechaHasta))
      setDataLeible(Object.values(resultReservasResumenLeible.data[0]).join(" "))
    } catch (error) {
      alert(error);
    }
  };

  const handleOnClickPrint = async (item) => {
    try {
      setLoading(true);
      const formato = "pdf"
      const reportData = await function_VEN_Reservas_Cabecera_ReporteReserva(item.IdReserva, formato);

      if (formato === 'pdf') {
        const file = new Blob([reportData], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = `Reserva${item.IdReserva}.pdf`; // Nombre del archivo con extensión
        link.click();
      } else if (formato === 'html') {
        const htmlContent = reportData.data;
        const newWindow = window.open();
        newWindow.document.write(htmlContent); // Mostrar HTML en nueva ventana
        newWindow.document.close();
      }

    } catch (error) {
      alert(error)
    } finally {
      setLoading(false);
    }
  };

  const handleOnClickEnviarEMail = async (item) => {
    try {
      setLoading(true);

      const idCliente = item.IdCliente;

      if (!idCliente) {
        alert("No se encontró un cliente asociado al Documento de Venta.");
        return;
      }

      // Llamar a la función para obtener la dirección de correo del cliente
      const resultCliente = await function_ABM_EEX_Clientes_Leer(idCliente);
      const correoElectronico = resultCliente?.data.Emails?.replace(" ", "; ") || "";

      // Mostrar popup para confirmar o editar el correo
      const nuevoCorreo = window.prompt(
        "Se enviará el E-Mail a la siguiente dirección o ingrese una nueva:",
        correoElectronico
      );

      if (!nuevoCorreo) {
        alert("El envío ha sido cancelado.");
        return;
      }

      const formato = "pdf"
      const reportData = await function_VEN_Reservas_Cabecera_ReporteReserva_EnvioMail(item.IdReserva, nuevoCorreo);

      alert("Se ha enviado el E-Mail")
    } catch (error) {
      alert(error)
    } finally {
      setLoading(false);
    }
  };

  return (
    <PaginaListado
      Titulo="RESERVAS"
      funcion={function_VEN_Reservas_Cabecera_Listar}
      onDataLoaded={handleDataLoaded}
      setDesde={setFechaDesde}
      setHasta={setFechaHasta}
    >
      {loading && (
        <div className="spinner-overlay">
          <div className="card-body text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Cargando...</span>
            </div>
          </div>
        </div>
      )}
      <div className="table-responsive">
        <div style={{ display: 'flex', alignItems: 'left', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>
          <LVButtonNuevo Url="/VEN_Reservas_ModificacionCreacion/--NUEVO--" visible={false} />

          <LVButtonReporte Url="/VEN_Reservas_ResumenDeActividades" Texto="RESUMEN DE ACTIVIDADES" />
          <LVButtonReporte Url="/VEN_Reservas_ResumenDeEventos" Texto="RESUMEN DE EVENTOS" />
          <LVButtonReporte Url="/VEN_Reservas_ResumenDeEventos_Calendario" Texto="RESUMEN DE EVENTOS - VISTA CALENDARIO" />

          <LVButtonReporte Url="/VEN_Reservas_CambioDeHorariosAforos" Texto="CAMBIO DE HORARIO Y AFORO" />
          <LVButtonReporte Url="/VEN_Reservas_CambioDeHorariosAforos_Excepciones" Texto="EXCEPCIONES HORARIO Y AFORO" />
          <LVButtonReporte Url="/VEN_Reservas_CambioDeHorariosAforos_HorariosReservados" Texto="AFORO RESERVADO" />
        </div>
        <div style={{ display: 'flex', alignItems: 'left', marginTop: '20px', marginBottom: '20px' }}>
          <text>
            <strong style={{ fontSize: '18px' }}>{dataLeible}</strong>
          </text>
        </div>
        {data.length > 0 ? (
          <LVGridCabecera
            dataSource={data}
            PageSize={11}
            id="gridContainer"
            keyExpr="IdReserva"
            urlEdicion="/VEN_Reservas_ModificacionCreacion"
            onClickPrint={handleOnClickPrint}
            onClickEnviarEmail={handleOnClickEnviarEMail}
          >
            <Summary>
              <TotalItem
                column="IdReserva"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`} />
              <TotalItem
                column="ImporteNeto"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteIVA"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteBonificaciones"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteRecargos"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteTotal"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency" />
              <TotalItem
                column="Peso"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="number" />
              <TotalItem
                column="CantidadParticipantesCargados"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="number" />
              <TotalItem
                column="CantidadParticipantesSinCargar"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="number" />
              <TotalItem
                column="CantidadParticipantesCheckIn"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="number" />


              <GroupItem
                column="IdReserva"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`}
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteNeto"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteIVA"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteBonificaciones"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteRecargos"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteTotal"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="Peso"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="number"
                showInGroupFooter={true} />
            </Summary>

            <Column caption="Código" dataField="IdReserva" width="120" alignment="Right" dataType="number" />
            <Column caption="Fecha" dataField="FechaCreacion" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
            <Column caption="Fecha" dataField="FechaSinHora" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} visible={false} />

            <Column caption="Evento" dataField="EsEvento" width="100" alignment="Center" dataType="boolean" />

            <Column caption="Cliente" alignment="Center" >
              <Column caption="Código" dataField="IdClienteGenerador" width="120" alignment="Right" dataType="number" />
              <Column caption="Descripción" dataField="ClienteGenerador" width="100%" minWidth={100} alignment="Left" dataType="string" />
              <Column caption="D.N.I." dataField="DNI" width="120" alignment="Right" dataType="string" />
              <Column caption="F.Nacimiento" dataField="FechaNacimiento" width="120" alignment="Right" dataType="date" format={'dd/MM/yyyy'} />
            </Column>

            <Column caption="Reserva" alignment="Center" >
              <Column caption="F.Inicio" dataField="FechaInicio" width="150" alignment="Right" dataType="date" format={'dd/MM/yyyy HH:MM:ss'} />
              <Column caption="Origen" dataField="Origen" width="100" alignment="Left" dataType="string" />

              <Column caption="Importes" alignment="Center">
                <Column caption="Total" dataField="ImporteTotal" width="120" alignment="Right" dataType="number" format="currency" />
                <Column caption="% Facturado" dataField="PorcentajeFacturado" width="120" alignment="Right" dataType="number" />
                <Column caption="% Recibido" dataField="PorcentajeRecibido" width="120" alignment="Right" dataType="number" />
              </Column>

              <Column caption="Participantes" alignment="Center" >
                <Column caption="Cargados" dataField="CantidadParticipantesCargados" width="100" alignment="Right" dataType="number" />
                <Column caption="Sin Cargar" dataField="CantidadParticipantesSinCargar" width="100" alignment="Right" dataType="number" />
                <Column caption="Check In" dataField="CantidadParticipantesCheckIn" width="100" alignment="Right" dataType="number" />
              </Column>

              <Column caption="Observaciones" dataField="Observaciones" width="200" alignment="Left" dataType="string" />
            </Column>

            <MasterDetail
              enabled={true}
              component={VEN_Reservas_Detalle}
            />
          </LVGridCabecera>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListado>
  );
};
